import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { sentry } from 'sentry';
import { environment } from '../../../../environments/environment';
import { ExportDialogComponentInjectedData } from './export-dialog.types';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { ExportDialogService } from './services/export-dialog.service';

@Component({
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExportDialogComponent {
  public email: string;
  public isExporting: boolean;
  public hasExceededLimit: boolean;
  public exceedLimitCount: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ExportDialogComponentInjectedData,
    public readonly matDialogRef: MatDialogRef<ExportDialogComponent>,
    private readonly authenticationService: AuthenticationService,
    private readonly customMessageService: CustomMessagesService,
    private readonly exportDialogService: ExportDialogService,
    private readonly fuseProgressBarService: FuseProgressBarService,
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService

  ) {
    this.isExporting = false;
    this.exceedLimitCount = this.data.limit;
    this.email = this.authenticationService.user && this.authenticationService.user.email;
    this.hasExceededLimit = this.data.limit && this.data.total && this.data.total > this.data.limit;

    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public async export(): Promise<void> {
    try {
      this.isExporting = true;
      this.fuseProgressBarService.show();

      const optionsFormValue = (this.data.optionsForm && this.data.optionsForm.value) || {};

      const input = this.exportDialogService.toCreateExportParams({
        type: this.data.type,
        where: this.data.where,
        include: Object.keys(optionsFormValue).filter((key) => Boolean(optionsFormValue[key]))
      });

      await this.exportDialogService.createExport(input);

      this.customMessageService.success('EXPORT_DIALOG.MESSAGES.EXPORT_SUCCESS', {}, {
        text: 'Ver exportações',
        callback: () => {
          location.href = environment.MOUNTDOOM_2_URL + '/#/exportacoes';
        }
      });
    } catch (err) {
      sentry.captureException(err, {
        extra: {
          dialogData: this.data
        }
      });

      this.customMessageService.error('EXPORT_DIALOG.MESSAGES.EXPORT_ERROR');
    } finally {
      this.isExporting = false;
      this.matDialogRef.close();
      this.fuseProgressBarService.hide();
    }
  }
}
